// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 70 ? "npm.regenerator-runtime" : chunkId) + "." + {"70":"2ef17536","776":"68a11606"}[chunkId] + ".chunk.js";
};